// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-content[data-v-0a21ca82] {\n  min-width: 6.197917rem;\n  overflow-x: hidden;\n}\n.footer-content .footer_links[data-v-0a21ca82] {\n  margin: 0.296875rem auto 0.072917rem;\n  font-size: 0.072917rem;\n  line-height: 0.125rem;\n  color: #000;\n}\n.footer-content .footer_links a[data-v-0a21ca82] {\n  padding: 0 0.026042rem;\n}\n.footer-content .noSelect[data-v-0a21ca82] {\n  font-size: 0.072917rem;\n  color: #666;\n}", ""]);
// Exports
module.exports = exports;
